module.exports = __webpack_public_path__ + "img/add-endpoint.d33bbcc8.png";